import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "currentColor",
      "fill-rule": "nonzero",
      class: "air-quality-svg-fill"
    }, [
      _createElementVNode("path", { d: "M9.516 9.5c0-.902.356-1.315.85-1.888a.937.937 0 0 0-1.42-1.224C8.365 7.062 7.641 7.9 7.641 9.5c0 1.598.724 2.438 1.305 3.112.494.573.85.986.85 1.888s-.356 1.315-.85 1.888a.937.937 0 0 0 1.42 1.224c.582-.674 1.306-1.514 1.306-3.112s-.724-2.438-1.306-3.112c-.494-.573-.85-.986-.85-1.888M14.203 9.5c0-.902.357-1.315.85-1.888a.938.938 0 0 0-1.42-1.224c-.58.674-1.305 1.513-1.305 3.112 0 1.598.724 2.438 1.306 3.112.494.573.85.986.85 1.888s-.356 1.315-.85 1.888a.937.937 0 1 0 1.42 1.224c.582-.674 1.306-1.514 1.306-3.112s-.724-2.438-1.306-3.112c-.494-.573-.85-.986-.85-1.888" }),
      _createElementVNode("path", { d: "M12 0C5.368 0 0 5.367 0 12c0 6.632 5.367 12 12 12 6.632 0 12-5.367 12-12 0-6.632-5.367-12-12-12m0 22.125A10.12 10.12 0 0 1 1.875 12 10.12 10.12 0 0 1 12 1.875 10.12 10.12 0 0 1 22.125 12 10.12 10.12 0 0 1 12 22.125" })
    ], -1)
  ])))
}
export default { render: render }